import AbstractDocument from "@/services/firebase/firestore/documents/AbstractDocument";
import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";
import {Expose} from "class-transformer";

export default class DocumentOthers extends AbstractDocument {
    @Expose({name: 'toastHuntingAgentsShow'})
    private _toastHuntingAgentsShow: boolean | null = null;
    @Expose({name: 'transfersEnable'})
    private _transfersEnable: boolean = false;
    @Expose({name: 'faqButtonsEnable'})
    private _faqButtonsEnable: boolean = false;
    @Expose({name: 'projectApiUrl'})
    private _projectApiUrl: string | null = null;
    @Expose({name: 'mainApiUrl'})
    private _mainApiUrl: string | null = null;
    @Expose({name: 'kodmobiApiUrl'})
    private _kodmobiApiUrl: string | null = null;
    @Expose({name: 'kodmobiApiKey'})
    private _kodmobiApiKey: string | null = null;
    @Expose({name: 'urlRules'})
    private _urlRules: string | null = null;
    @Expose({name: 'telegramBotSellNotifyUrl'})
    private _telegramBotSellNotifyUrl: string | null = null;
    @Expose({name: 'pusherKey'})
    private _pusherKey: string | null = null;
    @Expose({name: 'supportTg'})
    private _supportTg: DocumentOthersSupportTg | null = null;
    protected _type: DocumentTypes = DocumentTypes.OTHERS;

    constructor() {
        super();
    }

    get supportTg(): any | null {
        return this._supportTg;
    }

    get transfersEnable(): boolean {
        return this._transfersEnable;
    }

    get faqButtonsEnable(): boolean {
        return this._faqButtonsEnable;
    }

    get urlRules(): string | null {
        return this._urlRules;
    }

    get telegramBotSellNotifyUrl(): string | null {
        return this._telegramBotSellNotifyUrl;
    }

    get toastHuntingAgentsShow(): boolean | null {
        return this._toastHuntingAgentsShow;
    }

    get pusherKey(): string | null {
        return this._pusherKey;
    }

    get projectApiUrl(): string | null {
        return this._projectApiUrl;
    }

    get mainApiUrl(): string | null {
        return this._mainApiUrl;
    }

    get kodmobiApiKey(): string | null {
        return this._kodmobiApiKey;
    }

    get kodmobiApiUrl(): string | null {
        return this._kodmobiApiUrl;
    }

    public getSupportLink(currency: string): string | null {
        return this._supportTg?.[currency.toLowerCase()] ?? null;
    }
}

export type DocumentOthersSupportTg = Record<string, string | null>;
